import Raven from 'raven-js';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { ErrorPageContent } from 'pricing-pages-ui-components/components/ErrorPageContent';
import { DEFAULT } from 'pricing-pages-ui-components/constants/ErrorCauses';
import { SCREENS } from '../v2/constants/tracking/Screens';
import { Metrics } from '../utils/metrics';
import { trackClickedLink, trackPageView } from '../v2/utils/tracking/trackingEventUtils';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ErrorPage({
  errorCause = DEFAULT,
  additionalErrorLogging = {}
}) {
  useEffect(() => {
    console.error(`ErrorPage visited with error cause: ${errorCause}`);
    trackPageView({
      screen: SCREENS.ERROR
    });
    Metrics.counter('error-page-visited', {
      errorType: errorCause
    }).increment();
    Raven.captureMessage(`ErrorPage visited with error cause: ${errorCause}`, {
      extra: additionalErrorLogging
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    padding: "1000",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "ERROR_PAGE"
    }), /*#__PURE__*/_jsx(ErrorPageContent, {
      errorCause: errorCause,
      onClickLink: () => trackClickedLink({
        name: 'contact-support-page',
        type: 'external',
        url: window.location.href
      })
    })]
  });
}
export default ErrorPage;